// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Controllers_DocumentPrompt from "../Ouroboros.Programs.Controllers.DocumentPrompt/index.js";
var mkDocumentPromptEnv = function (input) {
    return {
        loading: input.kernel.loading,
        navigate: input.kernel.navigate,
        reviewRoute: input.kernel.reviewRoute,
        document: input.kernel.document,
        activeSection: input.kernel.activeSection,
        updateSection: input.kernel.updateSection,
        answerSectionQuestions: input.kernel.answerSectionQuestions,
        taskRunner: input.kernel.taskRunner
    };
};
var buildDocumentPromptViewProps = function (input) {
    var controller = Ouroboros_Programs_Controllers_DocumentPrompt.mkDocumentPromptController(mkDocumentPromptEnv(input));
    return {
        probingQuestion: input.probingQuestion,
        onSubmit: function (response) {
            return Ouroboros_Programs_Controllers_DocumentPrompt.runDocumentPromptAction(controller.submit(response));
        }
    };
};
export {
    buildDocumentPromptViewProps
};
//# sourceMappingURL=index.js.map
